import axios from 'axios';
import { API_BASE_URL } from '../../../constants';
import { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { TWhatsGoingOnItems } from '../Components/Organisms/WhatsGoingOnSection/WhatsGoingOnSection';
import { DefaultInstagramFeeds } from './Mock/InstagramFeeds';

const isMobileView = window.innerWidth < 768;

type TMediaType = 'IMAGE' | 'CAROUSEL_ALBUM' | 'VIDEO';

interface IInstagramFeedChildrenData {
  id: string;
  mediaType: TMediaType;
  mediaUrl: string;
}
interface IInstagramFeedData {
  id: string;
  timestamp: Date;
  mediaUrl: string;
  permalink: string;
  mediaType: TMediaType;
  children?: IInstagramFeedChildrenData[];
  caption?: string;
}

interface IResponseData {
  kickavenue: IInstagramFeedData[];
  kickavenue_luxury: IInstagramFeedData[];
  kickavenue_streetwear: IInstagramFeedData[];
}

const IG_FEEDS_URL = {
  main: 'https://feeds.behold.so/ssfGgbGkW3FIUnU137Zi',
  luxury: 'https://feeds.behold.so/3AR5R91OS8BZ9H7IwRIV',
  streetwear: 'https://feeds.behold.so/8qTvNB38x2JMTscYxCHj',
};

export const useFetchInstagramFeedData = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<TWhatsGoingOnItems[]>([]);

  useEffect(() => {
    setIsLoading(true);
    const constructData = (responseData: IInstagramFeedData[], percentage: number) => {
      if (!responseData.length) {
        return [];
      }
      const newValue: TWhatsGoingOnItems[] = [];
      const percentageCount = percentage / 100;
      const sliceCount = isMobileView ? 2 : 30 * percentageCount;

      if (responseData && responseData.length > 0) {
        responseData.forEach((data) => {
          const { mediaUrl: image, permalink: redirectUrl, caption } = data;
          if (data.mediaType === 'IMAGE') {
            newValue.push({
              image,
              redirectUrl,
              caption,
            });
          }

          if (data.mediaType === 'CAROUSEL_ALBUM' && data.children) {
            const children: IInstagramFeedChildrenData[] = data.children;
            if (children.length) {
              const childrenImage = children.find(
                (child) => child.mediaType === 'IMAGE',
              );
              if (childrenImage) {
                newValue.push({
                  image: childrenImage.mediaUrl,
                  redirectUrl,
                  caption,
                });
              }
            }
          }
        });
      }

      return newValue.slice(0, sliceCount);
    };

    axios
      .get(`${API_BASE_URL}/instagram-feeds`)
      .then((res) => {
        const responseData = res.data.data as IResponseData;
        const { kickavenue, kickavenue_luxury, kickavenue_streetwear } =
          responseData;

        const feeds = [
          ...constructData(kickavenue, 50),
          ...constructData(kickavenue_luxury, 30),
          ...constructData(kickavenue_streetwear, 20),
        ];

        if (feeds.length) {
          setData(feeds);
          return responseData;
        }

        setData(DefaultInstagramFeeds);
        return responseData;
      })
      .catch((err) => {
        console.log(err);
        setData(DefaultInstagramFeeds);
        setIsLoading(false);
        return [];
      });

    return () => {
      setIsLoading(false);
      setData([]);
    };
  }, []);

  return {
    isLoading,
    data,
  };
};
